import { DefaultSearch, SearchKeyword } from "../../Model/Content";
import { CheckUser, getGeoInfo } from "../../Model/Users";

import React, { useState, useEffect } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FreeMode, Pagination, Navigation } from "swiper";
import { motion } from "framer-motion";
import { Childlock } from "../Childlock/Childlock";
import {
  SVGIcons,
  ImgIcons,
  VirsionCheck,
  withRouter,
  getslug,
} from "../../Helpers/Common";
import BarLoader from "react-spinners/BarLoader";
import {
  BrowserRouter as Router,
  Routes,
  useParams,
  Route,
  Link,
} from "react-router-dom";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import Notifcationdesk from "../../components/Notifcationdesk/Notifcationdesk";
import { isMobile } from "react-device-detect";
var ImageData = "";
var SVGIcon = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DefaultSearch: false,
      slug: "",
      userData: false,
      inputValue: "",
      // showShimmer: true,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  // handleTimeout = () => {
  //   this.setState({ showShimmer: false });
  // };

  // componentDidMount() {
  //   this.timer = setTimeout(() => {
  //     this.setState({ showShimmer: false });
  //   }, 1000);
  // }

  // componentWillUnmount() {
  //   clearTimeout(this.timer);
  // }

  componentDidMount() {
    CheckUser().then((getuserdata) => {
      getGeoInfo().then((res) => {
        DefaultSearch(res).then((DefaultSearchResp) => {
          this.setState({
            DefaultSearch: JSON.parse(DefaultSearchResp.data.message.body),
            SearchIcon: true,
            userData: getuserdata.user_data,
          });
        });
      });
    });
  }

  handleChange(e) {
    this.setState({
      inputValue: e.target.value,
    });
    var SearchKey = e.target.value;
    getGeoInfo().then((res) => {
      var PostData = {
        searchkeyword: SearchKey,
      };

      this.setState({ searchkeyword: SearchKey });

      function debounceAndThrottle(func, delay) {
        let timeout;
        let lastRun = 0;

        return function executedFunction(...args) {
          const context = this;
          const currentTime = new Date().getTime();

          clearTimeout(timeout);

          if (currentTime - lastRun >= delay) {
            func.apply(context, args);
            lastRun = currentTime;
          } else {
            timeout = setTimeout(() => {
              func.apply(context, args);
              lastRun = new Date().getTime();
            }, delay - (currentTime - lastRun));
          }
        };
      }

      const delayedSearch = debounceAndThrottle((value) => {
        if (value.length >= 3) {
          console.log(value);
          SearchKeyword(PostData, res).then((SearchkeywordResp) => {
            if (SearchkeywordResp.data.message.body) {
              this.setState({
                DefaultSearch: JSON.parse(SearchkeywordResp.data.message.body),
                SearchIcon: false,
              });
            }
          });
        } else {
          DefaultSearch(res).then((DefaultSearchResp) => {
            this.setState({
              DefaultSearch: JSON.parse(DefaultSearchResp.data.message.body),
              SearchIcon: true,
            });
          });
        }
      }, 500);

      const { value } = e.target;
      this.setState({ inputValue: value });
      delayedSearch(value);
    });

    // this.setState({
    //   inputValue: e.target.value,
    // });
    // this.setState({ slug: e.target.value });

    // var SearchKey = e.target.value;

    // if (SearchKey == "") {
    //   getGeoInfo().then((res) => {
    //     DefaultSearch(res).then((DefaultSearchResp) => {
    //       this.setState({
    //         DefaultSearch: JSON.parse(DefaultSearchResp.data.message.body),
    //         SearchIcon: true,
    //       });
    //     });
    //   });
    // } else {
    //   getGeoInfo().then((res) => {
    //     var PostData = {
    //       searchkeyword: SearchKey,
    //     };
    //     SearchKeyword(PostData, res).then((SearchkeywordResp) => {
    //       this.setState({
    //         DefaultSearch: JSON.parse(SearchkeywordResp.data.message.body),
    //         SearchIcon: false,
    //       });
    //     });
    //   });
    // }
  }

  searchResult = (key) => {
    console.log(key);
    this.setState({
      inputValue: key,
    });
    getGeoInfo().then((res) => {
      var PostData = {
        searchkeyword: key,
      };
      SearchKeyword(PostData, res).then((SearchkeywordResp) => {

        this.setState({
          DefaultSearch: JSON.parse(SearchkeywordResp.data.message.body),
          SearchIcon: false,
        });
      });
    });
  };

  render() {
    var TrendingSearch;
    var DefaultSearch;
    var Noresult;
    if (this.state.DefaultSearch === false) {
      // return <div className="loader"></div>;
      return (
        <div className="loader">
          <BarLoader color="#ff000f" />
        </div>
      );
    } else {
      if (this.state.DefaultSearch.trendingSearch) {
        TrendingSearch = (
          <section className="mb-0">
            <div className="temp30 temp30-ser dD-none">
              {/* {this.showShimmer ? (
                <div className="line linehead" />
              ) : (
                <>     </>
                )} */}
              <div className="head-2">
                {this.state.DefaultSearch.trendingSearch.displayTitle}{" "}
                <span className="red">
                  {this.state.DefaultSearch.trendingSearch.displayTitleSuffix}{" "}
                </span>
              </div>
              <div className="temp30-area">
                <Swiper
                  slidesPerView={3.2}
                  spaceBetween={10}
                  freeMode={true}
                  loop={false}
                  loopFillGroupWithBlank={true}
                  centeredSlides={false}
                  modules={[FreeMode, Pagination]}
                  breakpoints={{
                    700: {
                      slidesPerView: 6.8,
                    },
                  }}
                  className="temp30-slider"
                >
                  {this.state.DefaultSearch.trendingSearch.contents.map(
                    (data, index) => {
                      return (
                        <SwiperSlide key={data.ID} className="temp30-item">
                          {/* {this.showShimmer ? (
                            <div className="line linehead" style={{ margin: "0", width: "135px" }} />
                          ) : (
                            <>    </>
                            )} */}
                          <div
                            onClick={() =>
                              this.searchResult(data.search_keyword)
                            }
                          >
                            <div className="temp30-itemColor">
                              {data.search_keyword}
                            </div>
                          </div>

                        </SwiperSlide>
                      );
                    }
                  )}
                </Swiper>
              </div>
            </div>
            <div className="dD-block">
              {/* {this.showShimmer ? (
                <div className="line linehead" />
              ) : (
                <>
                    </>
              )} */}
              <div className="head-2">
                {this.state.DefaultSearch.trendingSearch.displayTitle}{" "}
                <span className="red">
                  {this.state.DefaultSearch.trendingSearch.displayTitleSuffix}{" "}
                </span>
              </div>

              <div className="temp30-area">
                <div className="side-overlay-L dD-block"></div>
                <div className="side-overlay-R dD-block"></div>
                <Swiper
                  navigation={{
                    prevEl: ".slick-prev",
                    nextEl: ".slick-next",
                  }}
                  slidesPerView={3.2}
                  spaceBetween={10}
                  freeMode={true}
                  loop={false}
                  loopFillGroupWithBlank={true}
                  centeredSlides={false}
                  breakpoints={{
                    650: {
                      slidesPerView: 1,
                    },
                    850: {
                      slidesPerView: 6.3,
                    },
                  }}
                  modules={[FreeMode, Pagination, Navigation]}
                  className="temp30-slider"
                >
                  <button
                    className="slick-prev slick-arrow"
                    type="button"
                    aria-label="Previous"
                  />
                  {this.state.DefaultSearch.trendingSearch.contents.map(
                    (data, index) => {
                      return (
                        <SwiperSlide key={data.ID} className="temp30-item">
                          {/* {this.showShimmer ? (
                            <img src={ImageData["placeholder2.png"]} alt="shimmer" className="shimmer" />
                          ) : (
                            <>
                               </>
                          )} */}
                          <Link
                            to={"/search/" + data.search_keyword.toLowerCase()}
                          >
                            <div className="temp30-itemColor">
                              {data.search_keyword}
                            </div>
                          </Link>
                        </SwiperSlide>
                      );
                    }
                  )}
                  <button
                    className="slick-next slick-arrow"
                    type="button"
                    aria-label="Next"
                  />
                </Swiper>
              </div>
            </div>
          </section>
        );
      }
      if (this.state.DefaultSearch.success == true) {
        DefaultSearch = this.state.DefaultSearch.searchData.map(
          (MasterDefault, index) => {
            return (
              <section className="mb-0" key={MasterDefault.ID}>
                <div className="temp14 temp14-bay search dD-none">
                  {/* {this.showShimmer ? (
                    <div className="line linehead" />
                  ) : (
                    <>     </>
                    )} */}
                  <div className="head temp14-head">
                    <h4>
                      {MasterDefault.displayTitle}
                      <span className="red">
                        {" "}
                        {MasterDefault.displayTitleSuffix}
                      </span>
                    </h4>
                  </div>
                  <div className="temp14-area">
                    <Swiper
                      slidesPerView={2.4}
                      spaceBetween={16}
                      freeMode={true}
                      loop={false}
                      loopFillGroupWithBlank={true}
                      centeredSlides={false}
                      modules={[FreeMode, Pagination]}
                      breakpoints={{
                        700: {
                          slidesPerView: 4.2,
                        },
                      }}
                      className="temp14-slider"
                    >
                      {MasterDefault.contents.map((data, indexin) => {
                        var keyword = data.keywords.split(",");
                        keyword = keyword[0];
                        var premium = "";
                        if (data.premium && !data.original_tag) {
                          var premium = (
                            <img
                              src={this.props.silverIcon}
                              style={{
                                width: "1.3rem",
                                "margin-right": "3px",
                                "margin-bottom": "2px",
                              }}
                            />
                          );
                        }
                        if (data.original_tag && data.premium) {
                          var original = (
                            <img
                              src={this.props.goldenIcon}
                              style={{
                                width: "1.3rem",
                                "margin-right": "3px",
                                "margin-bottom": "2px",
                              }}
                            />
                          );
                        }
                        return (
                          <SwiperSlide key={data.ID} className="temp14-item">
                            {/* {this.showShimmer ? (
                              <img src={ImageData["placeholder2.png"]} alt="shimmer" className="shimmer" />
                            ) : (
                              <>   </>
                              )} */}
                            <div className="temp14-itemColor">
                              <Link to={"/" + data.slug}>
                                <img
                                  src={data.vertical_banner.small}
                                  alt="DocuBay"
                                />
                              </Link>
                            </div>
                            <div className="bay-title">{keyword}</div>
                            <div className="premium-red">
                              {premium}
                              {original}
                            </div>
                          </SwiperSlide>
                        );
                      })}
                      <SwiperSlide></SwiperSlide>
                    </Swiper>
                  </div>
                </div>
                <div className="temp14 temp14-bay search dD-block">
                  <div className="head temp14-head">
                    <h4>
                      {MasterDefault.displayTitle}
                      <span className="red">
                        {" "}
                        {MasterDefault.displayTitleSuffix}
                      </span>
                    </h4>
                  </div>
                  <div className="temp14-area">
                    <div className="side-overlay-L dD-block"></div>
                    <div className="side-overlay-R dD-block"></div>
                    <Swiper
                      navigation={{
                        prevEl: ".slick-prev",
                        nextEl: ".slick-next",
                      }}
                      slidesPerView={2.4}
                      spaceBetween={16}
                      freeMode={true}
                      loop={false}
                      loopFillGroupWithBlank={true}
                      centeredSlides={false}
                      breakpoints={{
                        650: {
                          slidesPerView: 1,
                        },
                        850: {
                          slidesPerView: 6.3,
                        },
                      }}
                      modules={[FreeMode, Pagination, Navigation]}
                      className="temp14-slider"
                    >
                      <button
                        className="slick-prev slick-arrow"
                        type="button"
                        aria-label="Previous"
                      />
                      {MasterDefault.contents.map((data, indexin) => {
                        var keyword = data.keywords.split(",");
                        keyword = keyword[0];
                        var premium = "";
                        if (data.premium && !data.original_tag) {
                          var premium = (
                            <img
                              src={this.props.silverIcon}
                              style={{
                                width: "1.7rem",
                                "margin-right": "3px",
                                "margin-bottom": "2px",
                              }}
                            />
                          );
                        }
                        if (data.original_tag && data.premium) {
                          var original = (
                            <img
                              src={this.props.goldenIcon}
                              style={{
                                width: "1.7rem",
                                "margin-right": "3px",
                                "margin-bottom": "2px",
                              }}
                            />
                          );
                        }
                        // if (data.premium_tag) {
                        //   var premium = <img src={SVGIcon["Premvg.svg"]} />;
                        // }
                        return (
                          <SwiperSlide key={data.ID} className="temp14-item">
                            <div className="temp14-itemColor">
                              <Link to={data.slug}>
                                <img
                                  src={data.vertical_banner.small}
                                  alt="DocuBay"
                                />
                              </Link>
                            </div>
                            <div className="bay-title">{keyword}</div>
                            <div className="premium-red">
                              {premium}
                              {original}
                            </div>
                          </SwiperSlide>
                        );
                      })}
                      <button
                        className="slick-next slick-arrow"
                        type="button"
                        aria-label="Next"
                      />
                    </Swiper>
                  </div>
                </div>
              </section>
            );
          }
        );
      }

      if (this.state.DefaultSearch.success == false) {
        Noresult = (
          <section className="mb-0">
            <div className="notification-message">
              <p>
                {this.state.DefaultSearch.message} <span></span>
              </p>
            </div>
          </section>
        );
      }

      return (
        <motion.div
          className=""
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0 }}
          key="1"
        >
          <div className="search-box dD-none">
            <div className="search-head">
              <div className="docubayBack white pl-8 mt-0">Search</div>
              {this.props.closefrom ? (
                <div className="topQuestion">
                  <img
                    src={SVGIcon["search-close.svg"]}
                    alt="DocuBay"
                    className="search-close"
                    onClick={() => {
                      this.props.functions.SearchClose();
                    }}
                  />
                </div>
              ) : (
                <div className="topQuestion">
                  <Link to="/">
                    <img
                      src={SVGIcon["search-close.svg"]}
                      alt="DocuBay"
                      className="search-close"
                    />
                  </Link>
                </div>
              )}
            </div>
            <section className="mb-0">
              <div className="search-fild">
                <div className="formField">
                  <input
                    type="text"
                    name="password"
                    autoComplete="off"
                    placeholder="Search for a title, topic or keyword"
                    className="search-inpt"
                    onChange={this.handleChange}
                    // value={this.state.slug}
                    value={this.state.inputValue || ""}
                  />
                  {/* <span className="temp34-clear">CLEAR</span> */}
                  {/* <div className="valid-msg">
                  <p>Showing Results for : amaz </p>
              </div> */}
                </div>
              </div>
            </section>
            {TrendingSearch}
            {DefaultSearch}
            {Noresult}
          </div>
          {/* <main className="dD-block">
            <div className="search-desk" href="">
              <input
                type="text"
                name="password"
                autoComplete="off"
                placeholder="Search for a title, topic or keyword"
                // className="search-inpt-desk"
                onChange={this.handleChange}
                value={this.state.slug}
              />
            </div>
            <div className="home-main">
              <div className="search-head">
                {this.props.closefrom ? (
                  <div className="topQuestion">
                    <img
                      src={SVGIcon["search-close.svg"]}
                      alt="DocuBay"
                      className="search-close"
                      onClick={() => {
                        this.props.functions.SearchClose();
                      }}
                    />
                  </div>
                ) : (
                  <div className="topQuestion">
                    <Link to="/">
                      <img
                        src={SVGIcon["search-close.svg"]}
                        alt="DocuBay"
                        className="search-close"
                      />
                    </Link>
                  </div>
                )}
              </div>
              {TrendingSearch}
              {DefaultSearch}
              {Noresult}
            </div>
            <Mobilemenu active="1" />
          </main> */}
          {this.state.userData != false ? (
            <Childlock data={this.state.userData} />
          ) : null}
        </motion.div>
      );
    }
  }
}

export default withRouter(Search);
